// extracted by mini-css-extract-plugin
export var active = "languageToggle-module--active--9db34";
export var link = "languageToggle-module--link--1c56f";
export var toolTip = "languageToggle-module--toolTip--d453a";
export var wrapper = "languageToggle-module--wrapper--f45ef";